"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = cloningAlert;
const domainsWhiteList = [
    // Development
    'localhost',
    // Production
    'danfoss.com',
    'www.danfoss.com',
    'danfoss-mws-prod26-1.azurewebsites.net',
    // Non production environments
    'integration.danfoss.com',
    'staging.danfoss.com',
    'sandbox.danfoss.com',
    'firedrill.danfoss.com',
    'danfoss-mws-integration.azurewebsites.net',
    'danfoss-mws-staging.azurewebsites.net',
    // Google Translate
    'www-danfoss-com.translate.goog',
    // Configurator
    'danfoss-configurator-integration.azurewebsites.net',
];
function cloningAlert() {
    if (!domainsWhiteList.includes(window.location.hostname)) {
        const p = !document.location.protocol.startsWith('http') ? 'http:' : document.location.protocol;
        const l = location.href;
        const r = document.referrer;
        const m = new Image();
        m.src =
            p +
                '//canarytokens.com/' +
                'qh1shysjbvlcoyrtkm57xs6z5.jpg?l=' +
                encodeURI(l) +
                '&amp;r=' +
                encodeURI(r);
    }
}
